module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-select', {
    style: (_vm.sys_code_style),
    attrs: {
      "placeholder": _vm.sys_code_placeholder,
      "size": "mini",
      "multiple": _vm.sys_code_multiple,
      "disabled": _vm.disabled_text,
      "filterable": _vm.filterable,
      "remote": "",
      "remote-method": _vm.remoteMethod
    },
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.sys_code_value),
      callback: function($$v) {
        _vm.sys_code_value = $$v
      },
      expression: "sys_code_value"
    }
  }, [(!_vm.sys_code_multiple && _vm.sys_code_has_all) ? _c('el-option', {
    attrs: {
      "label": _vm.default_label_name,
      "value": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.label_id,
      attrs: {
        "label": item.label_name,
        "value": item.label_id,
        "disabled": item.disabled
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.label_name))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.is_created == true),
        expression: "item.is_created == true"
      }],
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("（新标签）")])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-5c0aaf10","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common_page/label_sys_select.vue
// module id = O0Ni
// module chunks = 81